import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { prop, compose } from 'ramda';
import { withHandlers } from 'recompose';

import { selectedSkuReset } from 'app/features/products/actions';
import { loginSelected } from 'app/features/authentication/actions/login';
import connect from 'app/libs/connect';
import Button from 'app/components/Button/Button';
import renderIf from 'app/enhancers/renderIf';
import { isLoginVisible, loginPath } from 'app/features/header/selectors';

const UI = ({ onClick, loginPath }) => (
  <Button
    to={loginPath}
    type="four"
    testId="header-up-sign-in"
    onClick={onClick}
  >
    <FormattedMessage id="buttons_signin" />
  </Button>
);

UI.propTypes = {
  onClick: PropTypes.func.isRequired,
  loginPath: PropTypes.string.isRequired,
};

UI.displayName = 'LoginButton';

const state = { loginPath, isLoginVisible };
const actions = { selectedSkuReset, loginSelected };

const onClick =
  ({ loginSelected, selectedSkuReset }) =>
  () => {
    selectedSkuReset();
    loginSelected();
  };

const LoginButton = compose(
  connect(state, actions),
  renderIf(prop('isLoginVisible')),
  withHandlers({ onClick }),
)(UI);

export { UI, onClick };

export default LoginButton;
